import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const DOWNLOAD_FORM_SUMMARY_REQUEST = 'DOWNLOAD_FORM_SUMMARY_REQUEST';
export const DOWNLOAD_FORM_SUMMARY_SUCCESS = 'DOWNLOAD_FORM_SUMMARY_SUCCESS';
export const DOWNLOAD_FORM_SUMMARY_FAILURE = 'DOWNLOAD_FORM_SUMMARY_FAILURE';
export const GET_FORM_SUMMARY_PDF_CLEAR = 'GET_FORM_SUMMARY_PDF_CLEAR';

function request() {
  return {
    type: DOWNLOAD_FORM_SUMMARY_REQUEST,
    isDownloadingFormSummary: true
  };
}

function receive(formSummaryData) {
  return {
    type: DOWNLOAD_FORM_SUMMARY_SUCCESS,
    isDownloadingFormSummary: false,
    formSummaryData,
    dowloadFormSummaryError: null
  };
}

function reject(dowloadFormSummaryError) {
  return {
    type: DOWNLOAD_FORM_SUMMARY_FAILURE,
    isDownloadingFormSummary: false,
    dowloadFormSummaryError
  };
}

function clear() {
  return {
    type: GET_FORM_SUMMARY_PDF_CLEAR
  };
}

export function downloadFormSummary(formId) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .downloadFormSummary(formId, { responseType: 'arraybuffer' })
      .then((response) => {
        dispatch(receive(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}

export function clearPdfSummaryDownload() {
  return (dispatch) => {
    dispatch(clear());
  };
}
